import React, { useContext, useState, useEffect, useCallback, useLayoutEffect, useMemo } from 'react'

import { Link, Redirect, useHistory, useParams } from 'react-router-dom';

import { AcademyContext } from '../../../_contexts/UserContext';

import { LessonService } from '../../../_services/radacad-academy-lms/LessonService';
import NotFoundPage from '../../ErrorPage/NotFoundPage';

import { Button, Grid } from '@material-ui/core';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import FullScreenLoadingProgress from '../../_commons/FullScreenLoadingProgressComponent/FullScreenLoadingProgress';
import LessonVideoFrame from './LessonVideoFrame';
import LessonPageTabs from './LessonPageTabs';
import { JwtHelper } from '../../../_services/radacad-auth-react/Helpers/JwtHelper'


export default function LessonPage() {



    let history = useHistory();
    let loginContext = useContext(AcademyContext);
    const params = useParams();


    const [_pageState, setPageState] = useState(0);//0:loading, -1: error, 1: success
    const [_lessonDetail, setLessonDetail] = useState({
        courseId: 0,
        lessonTitle: "",
        moduleId: 0,
        isPreview: false,
        preLesson: null,
        nextLesson: null,
        ownLesson: false,
        hasEnrollment: false,
        enrollmentStatus: null,
        isEnrollmentExpired: false,
        isEnrollmentInactive: false,
        isTrialSubscription: false,
        subscriptionStatus: null
    });

    useLayoutEffect(() => {
        setPageState(0);
    }, [params.LessonId])

    useEffect(() => {
        if (_pageState === 0) {
            if (params.LessonId !== null) {
                console.log("start lesson ap")
                LessonService.RequestLessonPublicDetail(
                    loginContext.loginState.accessToken,
                    params.LessonId,
                    (resp) => {
                        if (resp.status === 200) {

                            resp.json().then(
                                (data) => {
                                    setLessonDetail({ lessonId: params.LessonId, ...data });
                                    setPageState(1);
                                }

                            ).catch(
                                (e) => {
                                    setPageState(-1);
                                }
                            )
                        }
                        else {
                            setPageState(-1);

                        }
                    },
                    (error) => {
                        setPageState(-1);
                    });
            }
        }
    }, [_pageState, params.LessonId, loginContext.loginState.accessToken])




    const ChangeLessonFromLesson = useCallback(
        (lessonId) => {
            history.push(`/Lesson/${lessonId}`)
        },
        [history],
    )

    const renderVideoFrame = useMemo(
        () => <LessonVideoFrame
            lessonHeader={
                {
                    courseId: _lessonDetail.courseId,
                    lessonId: _lessonDetail.lessonId,
                    moduleId: _lessonDetail.moduleId,
                    lessonTitle: _lessonDetail.lessonTitle,
                    isPreview: _lessonDetail.isPreview
                }
            }
            nextLessonNavigationHandler={
                () => {
                    if (_lessonDetail.nextLesson !== null)
                        ChangeLessonFromLesson(_lessonDetail.nextLesson.lessonId)
                }
            }
        >
        </LessonVideoFrame>,
        [ChangeLessonFromLesson, _lessonDetail],
    )


    const RenderAdjLessonButton = () => {

        return <Grid container spacing={2} justify="center" style={{ marginTop: '5px' }}>
            <Grid item xs={12} sm={6}>
                {
                    _lessonDetail.preLesson !== null &&
                    (
                        <Link to={`/Lesson/${_lessonDetail.preLesson.lessonId}`}>
                            <Button
                                variant='outlined'
                                color='primary'
                                className={"myThemeButton"}
                                style={{ textTransform: 'none', width: '100%', height: '100%' }}
                                startIcon={<NavigateBeforeIcon></NavigateBeforeIcon>}

                            >
                                {_lessonDetail.preLesson.lessonTitle}
                            </Button>
                        </Link>
                    )
                }
            </Grid>
            <Grid item xs={12} sm={6}>
                {
                    _lessonDetail.nextLesson !== null
                    &&
                    (
                        <Link to={`/Lesson/${_lessonDetail.nextLesson.lessonId}`}>
                            <Button
                                variant='outlined'
                                color='primary'
                                className={"myThemeButton"}
                                style={{ textTransform: 'none', width: '100%', height: '100%' }}
                                endIcon={<NavigateNextIcon></NavigateNextIcon>}

                            >
                                {_lessonDetail.nextLesson.lessonTitle}
                            </Button>
                        </Link>
                    )
                }
            </Grid>
        </Grid>
    }

    const RenderEnrollmentStatusMessage = () => {
        // Only show message if user is logged in, has enrollment but no access
        if (!loginContext.loginState.isLoggedIn || !_lessonDetail.hasEnrollment || _lessonDetail.ownLesson || _lessonDetail.isPreview) {
            return null;
        }

        let message = '';
        let severity = 'warning';

        if (_lessonDetail.isEnrollmentExpired) {
            message = 'Your enrollment for this course has expired. Please renew your enrollment to continue accessing the lessons.';
            severity = 'error';
        } else if (_lessonDetail.isEnrollmentInactive) {
            message = 'Your enrollment for this course is not active. Please contact support for assistance.';
            severity = 'warning';
        }

        if (!message) {
            return null;
        }

        return (
            <Grid item xs={12}>
                <div style={{
                    padding: '16px 20px',
                    marginBottom: '16px',
                    //backgroundColor: severity === 'error' ? '#fff4f4' : '#fffbf0',
                    border: `2px solid ${severity === 'error' ? '#ff6b6b' : '#ffa726'}`,
                    //borderLeft: `4px solid ${severity === 'error' ? '#ff6b6b' : '#ffa726'}`,
                    borderRadius: '8px',
                    color: severity === 'error' ? '#d32f2f' : '#f57c00',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                    <strong style={{ fontSize: '16px' }}>{severity === 'error' ? '⚠️ Enrollment Expired' : '⚠️ Enrollment Inactive'}</strong>
                    <p style={{ margin: '8px 0 0 0', lineHeight: '1.5' }}>{message}</p>
                </div>
            </Grid>
        );
    };

    const RenderTrialLabel = () => {
        // Only show trial label if user is logged in, owns the lesson, and has trial subscription
        if (!loginContext.loginState.isLoggedIn || !_lessonDetail.ownLesson || !_lessonDetail.isTrialSubscription || _lessonDetail.isPreview) {
            return null;
        }

        return (
            <Grid item>
                <div style={{
                    display: 'inline-block',
                    padding: '6px 16px',                 
                    border: '2px solid #2196f3',
                    borderRadius: '20px',
                    color: '#1565c0',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    marginLeft: '12px'
                }}>
                    🎯 Trial Watching
                </div>
            </Grid>
        );
    };


    return params.LessonId === null ? <Redirect to="/" push />
        : _pageState === -1 ? <NotFoundPage></NotFoundPage>
            : _pageState === 0 ? <FullScreenLoadingProgress></FullScreenLoadingProgress>
                : <Grid container spacing={2}>
                    <Grid item xs={12} md={true}>

                        <Grid container spacing={2}>

                            <Grid item>
                                <Link to={`/Course/${_lessonDetail.courseId}/Modules`}>
                                    <Button
                                        variant='outlined'
                                        color='primary'
                                        className='myThemeButton'
                                    >
                                        Back to Lesson List
                                    </Button>
                                </Link>
                            </Grid>
                            <Grid item>
                                <h2>{_lessonDetail.lessonTitle}</h2>
                            </Grid>
                            {RenderTrialLabel()}
                            {RenderEnrollmentStatusMessage()}
                            <Grid item xs={12}>
                                <Grid container justify="center">
                                    <Grid item xs={12}>
                                        {renderVideoFrame}
                                    </Grid>
                                    <Grid item xs={12}>{RenderAdjLessonButton()}</Grid>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                    {loginContext.loginState.isLoggedIn && _lessonDetail.ownLesson
                        && <Grid item xs={12} md={'auto'} style={{ minWidth: '22.5%' }}>
                            <LessonPageTabs
                                userId={JwtHelper.GetUserId(loginContext.loginState.accessToken)}
                                lessonInfo={{ courseId: _lessonDetail.courseId, lessonId: _lessonDetail.lessonId }}
                            ></LessonPageTabs>
                        </Grid>}
                </Grid>


}
